module.exports = __webpack_public_path__ + "static/media/Vonique64.f671f7ed.ttf";